import * as React from "react";

export const AnimatedLoaderEllipsis: React.FC = () => (
  <span className="textual-loading-indicator" aria-hidden="true" />
);
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";